import type { ReactNode } from 'react';

export function PageHeader({
    title,
    description,
    actions,
}: {
    title: string;
    description?: string;
    actions?: ReactNode;
}) {
    return (
        <div className="mb-2 flex flex-wrap items-end justify-between gap-4">
            <div className="space-y-2">
                <h1 className="text-2xl font-bold sm:text-3xl">{title}</h1>
                <span aria-hidden="true" className="block h-1 w-10 rounded-full bg-brand" />
                {description && <p className="max-w-3xl text-muted">{description}</p>}
            </div>
            {actions}
        </div>
    );
}
